import { useQuery, gql } from '@apollo/client';

export const GET_WAGES_AND_SALARY = gql`
  query getWagesAndSalary($memberId: String!) {
    getWagesAndSalary(memberId: $memberId) {
      collection {
        _id
        companyId
        memberId
        salaryType
        amount
        startDate
      }
    }
  }
`;

export const useGetWagesAndSalary = ({ memberId }: { memberId: string }) => {
  const { data, loading } = useQuery(GET_WAGES_AND_SALARY, {
    variables: {
      memberId,
    },
    skip: !memberId,
    fetchPolicy: 'cache-and-network',
  });

  return {
    collection: data?.getWagesAndSalary?.collection || [],
    loading,
  };
};
